(function() {
  // === Pack Discovery · regalo automático al superar el umbral (sin recargar) ===
  const GIFT_VARIANT_ID = 54115650339157; // variante del Pack Discovery
  const THRESHOLD_CENTS = 5000;            // 50,00 €

  let working = false;

  function giftLineIndex(items) {
    for (let i = 0; i < items.length; i++) {
      if (items[i].variant_id === GIFT_VARIANT_ID) return i + 1;
    }
    return -1;
  }

  function eligibleTotal(cart) {
    let total = 0;
    cart.items.forEach(function(it) {
      if (it.variant_id !== GIFT_VARIANT_ID) total += it.final_line_price;
    });
    return total;
  }

  function refreshThemeCart() {
    // Pide al tema que repinte el carrito/drawer sin recargar la página.
    // Se disparan varios eventos comunes para cubrir distintos temas.
    ['cart:refresh','cart:updated','cart:build','cart:rerender'].forEach(function(name){
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });
    if (window.jQuery) {
      try { jQuery(document).trigger('cart.requestComplete'); } catch(e){}
    }
  }

  function addGift() {
    if (working) return;
    working = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
    }).then(function(){ working = false; refreshThemeCart(); })
      .catch(function(){ working = false; });
  }

  function removeGift(line) {
    if (working) return;
    working = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    }).then(function(){ working = false; refreshThemeCart(); })
      .catch(function(){ working = false; });
  }

  function sync() {
    if (working) return;
    return fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        const line = giftLineIndex(cart.items);
        const total = eligibleTotal(cart);
        if (total >= THRESHOLD_CENTS && line === -1) {
          return addGift();
        } else if (total < THRESHOLD_CENTS && line !== -1) {
          return removeGift(line);
        }
      });
  }

  // --- Interceptar fetch: cuando el tema toca el carrito, re-sincronizamos ---
  const _fetch = window.fetch;
  window.fetch = function() {
    const url = (arguments[0] && arguments[0].url) ? arguments[0].url : arguments[0];
    const p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
      // No re-sincronizar si la llamada la hicimos nosotros mismos
      if (!working) {
        p.then(function(){ setTimeout(sync, 200); });
      }
    }
    return p;
  };

  // --- Interceptar XMLHttpRequest (algunos temas usan XHR en vez de fetch) ---
  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.addEventListener('load', function() {
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        if (!working) setTimeout(sync, 200);
      }
    });
    return _open.apply(this, arguments);
  };

  // Sincroniza al cargar la página
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();